import { SCREENS } from "utils/constants";
import Create from "./Create";
import Edit from "./Edit";
import List from "./List";

const routes = [
  {
    path: SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.LIST.path,
    exact: true,
    element: <List />,
  },
  {
    path: SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.CREATE.path,
    exact: true,
    element: <Create />,
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.EDIT.path}/:id`,
    element: <Edit />,
  },
];

export default routes;
